// クーポンを獲得 (/pages/get-coupon). Port shop.get_coupon.php:
// đọc ?ci= → chưa login thì giữ ci + redirect login (quay lại sau) → đã login
// thì POST /coupon/redeem qua inkApi → grant. Chờ ink:api:ready.
// §Loading: dùng state skeleton (auto-redeem lúc load, KHÔNG phải nút bấm).

(function () {
  'use strict';

  const PENDING_KEY = 'ink_pending_coupon';

  function couponId(value) {
    return String(value == null ? '' : value);
  }

  function couponExpiryValue(coupon) {
    if (!coupon) return null;
    return coupon.coupon_use_end || coupon.valid_until || coupon.expires_at || null;
  }

  function formatExpiry(coupon) {
    const value = couponExpiryValue(coupon);
    if (!value) return '';

    let date;
    if (typeof value === 'number' || /^\d+$/.test(String(value))) {
      const numeric = Number(value);
      date = new Date(numeric < 1000000000000 ? numeric * 1000 : numeric);
    } else {
      date = new Date(String(value).trim().replace(' ', 'T'));
    }
    if (Number.isNaN(date.getTime())) return '';

    const pad = (number) => String(number).padStart(2, '0');
    const fixedEnd = Number(coupon.anniversary_coupon_flg) === 1 || Number(coupon.final_order_coupon_flg) === 1;
    const time = fixedEnd ? '23:59' : `${pad(date.getHours())}:${pad(date.getMinutes())}`;
    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日 ${time}まで`;
  }

  async function loadCouponDetails(redeemed) {
    if (couponExpiryValue(redeemed)) return redeemed;

    try {
      const summary = await window.inkApi.get('/mypage/summary');
      const coupons = summary && summary.data && Array.isArray(summary.data.coupons)
        ? summary.data.coupons
        : [];
      const detail = coupons.find((coupon) => couponId(coupon.coupon_id) === couponId(redeemed.coupon_id));
      return detail ? Object.assign({}, redeemed, detail) : redeemed;
    } catch (e) {
      console.warn('[get-coupon] coupon detail fetch failed', e);
      return redeemed;
    }
  }

  // Reason code backend → message tiếng Nhật (mirror shop.get_coupon.php).
  function reasonMessage(reason) {
    switch (reason) {
      case 'invalid_link':
        return 'クーポンコードが正しくありません。';
      case 'fo_user_exempt':
        return '※クーポンを取得できません。詳細はカスタマーサポートまでお問い合わせください。';
      case 'already_acquired':
      case 'already_used':
      case 'expired':
      case 'not_started':
      case 'anniversary_window_closed':
        return 'クーポンはすでに取得済み、もしくは有効期限切れです。';
      default:
        return 'クーポンを獲得できませんでした。';
    }
  }

  function boot() {
    const root = document.querySelector('[data-ink-get-coupon]');
    if (!root) return;

    const cfg = window.INK_GET_COUPON || {};
    const elLoading = root.querySelector('[data-gc-loading]');
    const elSuccess = root.querySelector('[data-gc-success]');
    const elError = root.querySelector('[data-gc-error]');
    const elLogin = root.querySelector('[data-gc-login]');
    const elName = root.querySelector('[data-gc-coupon-name]');
    const elExpiryRow = root.querySelector('[data-gc-coupon-expiry-row]');
    const elExpiry = root.querySelector('[data-gc-coupon-expiry]');
    const elErrMsg = root.querySelector('[data-gc-error-msg]');
    const elLoginLink = root.querySelector('[data-gc-login-link]');

    function show(el) {
      [elLoading, elSuccess, elError, elLogin].forEach((e) => { if (e) e.hidden = true; });
      if (el) el.hidden = false;
    }
    function showError(msg) {
      if (elErrMsg && msg) elErrMsg.textContent = msg;
      show(elError);
    }

    // ci từ URL; fallback localStorage (đã lưu trước khi đi login).
    const params = new URLSearchParams(window.location.search);
    let ci = params.get('ci') || '';
    if (!ci) {
      try { ci = window.localStorage.getItem(PENDING_KEY) || ''; } catch (e) { /* private mode */ }
    }

    if (!ci) {
      showError(reasonMessage('invalid_link'));
      return;
    }

    // Chưa login → giữ ci + hiện CTA login (quay lại trang này sau login).
    const loggedIn = cfg.loggedIn && window.inkApi && window.inkApi.shopifyCustomer;
    if (!loggedIn) {
      try { window.localStorage.setItem(PENDING_KEY, ci); } catch (e) { /* ignore */ }
      if (elLoginLink) {
        // New Customer Accounts: return_to (relative path + ?ci) để quay lại trang
        // này sau login → redeem. Khớp snippets/login-url.liquid.
        const ret = window.location.pathname + '?ci=' + encodeURIComponent(ci);
        const base = cfg.loginUrl || '/customer_authentication/login';
        elLoginLink.href = base + (base.indexOf('?') === -1 ? '?' : '&') + 'return_to=' + encodeURIComponent(ret);
      }
      show(elLogin);
      return;
    }

    // Đã login → redeem. inkApi.post LUÔN trả body JSON (không throw):
    //  thành công {data:{coupon_id,...}}; 422 {error:'...', reason:'...'};
    //  network/parse {data:null, error:{code:'NETWORK_ERROR'|'PARSE_ERROR'}}.
    (async () => {
      let res;
      try {
        res = await window.inkApi.post('/coupon/redeem', { ci });
      } catch (e) {
        console.warn('[get-coupon] redeem failed', e);
        showError('通信エラーが発生しました。時間をおいて再度お試しください。');
        return;
      }

      // Network/parse error (error là object có .code) → KHÔNG xoá pending (cho retry).
      if (res && res.error && typeof res.error === 'object' && res.error.code) {
        showError('通信エラーが発生しました。時間をおいて再度お試しください。');
        return;
      }

      const data = res && res.data;
      if (data && data.coupon_id) {
        try { window.localStorage.removeItem(PENDING_KEY); } catch (e) { /* ignore */ }
        const detail = await loadCouponDetails(data);
        if (elName) {
          // Chỉ hiện クーポン名 — KHÔNG hiện coupon_code: code là thứ ký ra link
          // `?ci=` nên hiện ra là khách copy/chia sẻ được. Tên rỗng (row legacy)
          // → ẩn luôn dòng cho khỏi hở khoảng trắng.
          const name = (detail.coupon_name || '').trim();
          elName.textContent = name;
          elName.hidden = name === '';
        }
        if (elExpiryRow && elExpiry) {
          const expiry = formatExpiry(detail);
          elExpiry.textContent = expiry;
          elExpiryRow.hidden = expiry === '';
        }
        show(elSuccess);
        return;
      }

      // 422 không đủ điều kiện → reason → message + xoá pending (không retry vô ích).
      try { window.localStorage.removeItem(PENDING_KEY); } catch (e) { /* ignore */ }
      showError(reasonMessage(res && res.reason));
    })();
  }

  let booted = false;
  function startOnce() { if (booted) return; booted = true; boot(); }
  if (window.inkApi) startOnce();
  else {
    document.addEventListener('ink:api:ready', startOnce, { once: true });
    window.addEventListener('load', () => setTimeout(() => { if (!window.inkApi) startOnce(); }, 1000));
  }
})();
